import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '内容导航',
    links: [
      { label: '首页推荐', href: '/' },
      { label: '分类浏览', href: '/category/free-platforms' },
      { label: '最新测评', href: '/category/paid-platforms' },
      { label: '安全指南', href: '/category/safety-guide' },
    ],
  },
  {
    title: '热门分类',
    links: [
      { label: '免费平台', href: '/category/free-platforms' },
      { label: '付费平台', href: '/category/paid-platforms' },
      { label: '高清影视', href: '/category/hd-movies' },
      { label: '海外平台', href: '/category/overseas' },
    ],
  },
  {
    title: '关于本站',
    links: [
      { label: '品牌介绍', href: '/about' },
      { label: '联系方式', href: '/about' },
      { label: '隐私政策', href: '/about' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-100">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-[1400px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div className="lg:col-span-1">
              <Link
                to="/"
                className="flex items-center gap-2 text-xl font-bold font-heading text-foreground-900 mb-4"
              >
                <span className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg">
                  <i className="ri-movie-2-line text-lg"></i>
                </span>
                <span>看片推荐</span>
              </Link>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                2025年最全面的在线观影平台推荐与测评网站。我们致力于为影迷提供专业、客观、安全的看片网站评测，助你找到最适合的观影平台。
              </p>
            </div>

            {footerLinks.map((group) => (
              <div key={group.title}>
                <h4 className="text-sm font-semibold text-foreground-900 mb-4 font-heading">
                  {group.title}
                </h4>
                <ul className="flex flex-col gap-2">
                  {group.links.map((link) => (
                    <li key={link.href}>
                      <Link
                        to={link.href}
                        className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-12 pt-8 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-foreground-500">
              &copy; {new Date().getFullYear()} 看片推荐 KanPianTuiJian. 保留所有权利。
            </p>
            <div className="flex items-center gap-4">
              <a
                href="#"
                className="text-foreground-400 hover:text-primary-600 transition-colors duration-200"
                aria-label="微信"
                rel="nofollow"
              >
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a
                href="#"
                className="text-foreground-400 hover:text-primary-600 transition-colors duration-200"
                aria-label="微博"
                rel="nofollow"
              >
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a
                href="#"
                className="text-foreground-400 hover:text-primary-600 transition-colors duration-200"
                aria-label="邮箱"
                rel="nofollow"
              >
                <i className="ri-mail-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}